import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h3>{`HTTP Errors`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Error ID`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Recovery Suggestion`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`unauthorized`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Indicates that the SDK's request lacks valid authentication credentials (HTTP 401).`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Check the server's response to debug this error further.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`client-error`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Indicates an error caused by the SDK's request (HTTP 4xx).`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Check the server's response to debug this error further.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`server-error`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Indicates an error caused by the server while processing the SDK's request (HTTP 5xx).`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Check the server's response to debug this error further.`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      